import React from "react";
import Lazycover from "components/lazycover";
import Logo from "components/logo";
import StickyBlock from "components/sticky-block";
import ContentWrapper from "components/content-wrapper";
import s from "./index.module.scss";
import Share from "components/share";

const Footer = () => (
	<StickyBlock zIndex={0}>
		<ContentWrapper as="footer" className={s.footer}>
			<Share />
			<div className={s.content}>
				<div className={s.credits}>
					<div className={s.title}>
						<h2>Над проектом работали:</h2>
					</div>
					<div>
						<ul className={s.people}>
							<li>Бильд-редактор: Илона Грибовская</li>
							<li>Креативный продюсер: Владислав Важник</li>
							<li>Дизайнер: Екатерина Седогина, Черкасова Марина</li>
							<li>Разработчик: Андрей Горошевский</li>
						</ul>
					</div>
				</div>
				<div className={s.copyrights}>
					<div className={s.logoContainer}>
						<Logo className={s.logo} />
					</div>
					<p className={s.copy}>
						ТАСС информационное агентство (свидетельство
						о&nbsp;регистрации СМИ №&nbsp;03247 выдано 2&nbsp;апреля
						1999&nbsp;г. Государственным комитетом Российской
						Федерации по&nbsp;печати). Отдельные публикации могут
						содержать информацию, не&nbsp;предназначенную для
						пользователей до&nbsp;16&nbsp;лет.
						<br />
						©&nbsp;ТАСС, 2019
					</p>
				</div>
			</div>
			<p className={s.author}>© Валерий Шарифулин/ТАСС</p>
			<Lazycover
				className={s.background}
				image={"images/bg_footer.jpg"}
			/>
		</ContentWrapper>
	</StickyBlock>
);

export default Footer;
